import Button from '@sats-group/ui-lib/react/button';
import Expander from '@sats-group/ui-lib/react/expander';
import SvgInfo from '@sats-group/ui-lib/react/icons/16/info';
import Modal from '@sats-group/ui-lib/react/modal';
import Select from '@sats-group/ui-lib/react/select';
import Text from '@sats-group/ui-lib/react/text';
import React, { useState } from 'react';
import ContentContainer from '~/client/components/content-container/content-container';
import Debt from '~/client/components/debt/debt';
import MyPageLayout from '~/client/components/my-page-layout/my-page-layout';
import PaymentReceiptGroup from '~/client/components/payment-receipt-group/payment-receipt-group';
import type { MyPagePayments as Props } from './my-page-payments.types';

const MyPagePayments: React.FunctionComponent<Props> = ({
  debt,
  layout,
  payments,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    if (isSubmitting) {
      event.preventDefault();
    }
    setIsSubmitting(true);
  };

  return (
    <MyPageLayout {...layout}>
      <ContentContainer>
        <div className="my-page-payments">
          {debt ? (
            <div className="my-page-payments__section">
              <Text
                elementName="h2"
                size={Text.sizes.headline3}
                theme={Text.themes.emphasis}
              >
                {debt.title}
              </Text>
              <Text elementName="p">{debt.help}</Text>
              {debt.entries.map(entry => (
                <div key={entry.id}>
                  <Debt {...entry} />
                </div>
              ))}
            </div>
          ) : null}
          {payments ? (
            <div className="my-page-payments__section">
              <div className="my-page-payments__section-header">
                <Text
                  elementName="h2"
                  size={Text.sizes.headline3}
                  theme={Text.themes.emphasis}
                >
                  {payments.title}
                </Text>

                <Button
                  text={payments.periodPicker.customReceiptCTA}
                  onClick={() => setShowModal(true)}
                  variant={Button.variants.secondary}
                  data-test-custom-picker-modal
                />
              </div>
              {showModal ? (
                <Modal
                  {...payments.periodPicker.modal}
                  onClose={() => setShowModal(false)}
                >
                  <form
                    method="get"
                    className="my-page-payments__period-picker-form"
                    onSubmit={handleSubmit}
                    action={payments.periodPicker.form.action}
                  >
                    <div className="my-page-payments__period-picker">
                      <Select {...payments.periodPicker.form.startMonth} wide />
                      <Select {...payments.periodPicker.form.startYear} wide />
                    </div>
                    <Select {...payments.periodPicker.form.duration} wide />
                    <div className="my-page-payments__period-picker-info">
                      <SvgInfo />
                      <Text elementName="p" size={Text.sizes.small}>
                        {payments.periodPicker.infoText}
                      </Text>
                    </div>
                    <Button
                      {...payments.periodPicker.form.submit}
                      className="my-page-payments__submit-button"
                      disabled={isSubmitting}
                      data-testid="custom-receipt"
                    />
                  </form>
                </Modal>
              ) : null}
              <div>
                {payments.entries.map(entry => (
                  <Expander
                    {...entry.props}
                    itemRenderer={PaymentReceiptGroup}
                    key={entry.key}
                  />
                ))}
              </div>
            </div>
          ) : null}
        </div>
      </ContentContainer>
    </MyPageLayout>
  );
};

export default MyPagePayments;
